export default __webpack_public_path__ + "static/media/logo-lg.af390787.png";